import { useEffect, useState } from 'react'
import { Alert, Button, Table } from 'react-bootstrap'
import { api, readData, readError } from '@/services/apiClient'
import type { ApiResponse } from '@/models/api'
type LogRow = { id: number; userName: string; eventDateTime: string; action: string; message: string }
export function RuntimeStatus() {
  const [status, setStatus] = useState<Record<string, unknown>>()
  const [logs, setLogs] = useState<LogRow[]>([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [error, setError] = useState('')
  useEffect(() => {
    let active = true
    Promise.all([api.get<ApiResponse<Record<string, unknown>>>('/system/status'), api.get<ApiResponse<{ rows: LogRow[]; totalRows: number }>>('/system/logs', { params: { page } })])
      .then(([a, b]) => { if (!active) return; setStatus(readData(a.data, {})); const result = readData(b.data, { rows: [], totalRows: 0 }); setLogs(result.rows); setTotal(result.totalRows) })
      .catch(e => { if (active) setError(readError(e)) })
    return () => { active = false }
  }, [page])
  return <section className="admin-panel">
    <h2 className="h5">Runtime status</h2>{error && <Alert variant="danger">{error}</Alert>}
    {status && <><p>Runtime configuration is managed in the hosting environment.</p><Table><tbody>{Object.entries(status).map(([key, value]) => <tr key={key}><th>{key.replace(/([A-Z])/g, ' $1')}</th><td>{typeof value === 'boolean' ? value ? 'Yes' : 'No' : String(value)}</td></tr>)}</tbody></Table></>}
    <h2 className="h5">Business audit log</h2><Table responsive><thead><tr><th>When</th><th>User ID</th><th>Operation</th><th>Record</th></tr></thead><tbody>{logs.map(row => <tr key={row.id}><td>{new Date(row.eventDateTime).toLocaleString()}</td><td>{row.userName}</td><td>{row.action}</td><td>{row.message}</td></tr>)}</tbody></Table>
    {!logs.length && <p>No activity recorded yet.</p>}<Button disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</Button>{' '}<Button disabled={page * 50 >= total} onClick={() => setPage(page + 1)}>Next</Button>
  </section>
}
